import type { EditableRow, SupportedByKeyMap } from './types';
import {
  formatGgusonepayMethodLabel,
  formatOnlineDebtMethodLabel,
  formatZeroxMethodIdLabel,
  getCoinVisual,
  GGUSONEPAY_CARD_SUBTITLE,
  normalizeSupportedMethodId,
  prettyMethodLabel,
  splitCoinAndNetworkLabel,
  toSupportedKey,
} from './utils';

type Props = {
  row: EditableRow;
  supportedByKey: SupportedByKeyMap;
};

export default function MethodCell({ row, supportedByKey }: Props) {
  const provider = (row.provider || '').toLowerCase();
  const operation = row.operation;
  const methodId = (row.methodId || 'all').toLowerCase();

  if (provider === 'online_debt') {
    const methodLabel = formatOnlineDebtMethodLabel(methodId);
    return (
      <div className="flex min-w-0 items-start gap-2">
        <span className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sky-500/20 text-xs font-bold text-sky-700">
          $
        </span>
        <span className="min-w-0">
          <span className="block truncate text-sm font-semibold text-stone-900">{methodLabel}</span>
          <span className="block truncate text-xs text-stone-500">USD wallet · internal transfer</span>
        </span>
      </div>
    );
  }

  const supported = supportedByKey[toSupportedKey(provider, String(operation || ''))] || [];
  const matched = supported.find((m) => normalizeSupportedMethodId(m).toLowerCase() === methodId);
  const ggusLabel = formatGgusonepayMethodLabel(methodId);
  const methodLabel =
    methodId === 'all'
      ? 'All'
      : matched
        ? prettyMethodLabel(matched)
        : ggusLabel
          ? ggusLabel
          : methodId.startsWith('zerox_')
            ? formatZeroxMethodIdLabel(methodId)
            : methodId;

  const { coin: coinPart, network: networkPart } = splitCoinAndNetworkLabel(methodLabel, methodId);
  const coinVisual = getCoinVisual(methodId, methodLabel);
  const subtitle = provider === 'ggusonepay' ? GGUSONEPAY_CARD_SUBTITLE : networkPart;

  return (
    <div className="flex min-w-0 items-start gap-2">
      <span
        className={`inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${coinVisual.colorClass} ${coinVisual.textClass}`}
      >
        {coinVisual.symbol}
      </span>
      <span className="min-w-0">
        <span className="block truncate text-sm font-semibold text-stone-900">{coinPart}</span>
        {subtitle ? (
          <span className="block truncate text-xs text-stone-500">{subtitle}</span>
        ) : null}
        {methodId.startsWith('zerox_') ? (
          <span className="block truncate font-mono text-[10px] text-stone-400">{methodId}</span>
        ) : null}
      </span>
    </div>
  );
}
